import * as React from 'react';
import '../dashboard/CustomFilter.css';
import './AnalyticsFilterItem.css';
import {
  IDropdownOption,
  FontIcon,
  NormalPeoplePicker,
  IPersonaProps,
  TextField,
  ComboBox,
  IDropdownStyles,
  ISelectableOption,
  Label,
  DatePicker,
  Toggle,
  mergeStyles,
} from '@fluentui/react';
import { LogicalOperator } from '../Models/LogicalOperator';
import { SQLOperator } from '../Models/SQLInOperator';
import { FieldValue } from '../Models/FieldValue';

import {
  GetSQLOperators,
  GetFieldValues,
  GetSolutionAreas,
  GetWorkItemStates,
  GetAreas,
  GetMilestoneStatusOptions,
  GetScopeOldOptions,
  GetFinancialYearOptions,
  GetQuarterOptions,
  GetTop5AskOptions,
  GetAzurePriorityOptions,
  GetTopicCategoryOptions,
  GetFeedbackTypeOptions,
  GetTriageValues,
  GetEngineeringContactValues,
  GetEngineeringStatus,
  GetActionCategories,
  GetEOUS,
  GetIndustryOptions,
  GetPatternGroup,
  GetMilestoneReason,
  GetMilestoneWorkloadOptions,
  GetHelpNeededOptions,
  GetOrgOptions,
  GetCustomIndustryOptions,
  GetCloudIntentreason,
  GetCompletionStatusIfCombined,
  GetNonRenewingReason,
  GetMeetingTypeOrigin,
  GetWorkloadType,
  GetAssistedMigrationreason,
  GetReason,
  GetIssue,
  GetActivity,
  GetFoundIn,
  GetIntegrationBuild,
  GetTestSuitType,
  GetAutomationStatus,
  GetValueArea,
  GetClosedStatus,
  GetClosedStatusCode,
  GetTrueFalse,
  GetPriorityOptions,
  GetRating,
  GetStateCode,
  GetWorkItemType,
  GetBoardColumn,
  GetSeverity,
  GetIterationPath,
  GetThemeOptions,
  GetAdditionalTheme,
  GetAssociatedType,
  GetDateValues,
  GetActionType,
  GetInterestedAssistedMigrationreason,
  GetMeetingSubTypes,
  GetAssignedToCorpValues,
  GetYesOrNo,
  GetApplicationType,
  GetServiceTreeOffering,
  GetServiceTreeOffering2,
  GetServiceTreeOffering3,
  GetEcifStatusIfFam,
  GetIdInValues,
  GetHelpNeededOpportunityOptions,
  GetDeliveryBlockers,
  GetEngagementCategoryOptions,
  GetEngagementRegionOptions,
  GetScenarioCohortOptions,
  GetFirstPartyOfferingOptions,
  GetFirstPartySolutionOptions,
  GetThirdPartySolutionOptions,
  GetOpportunityStatusOptions,
  GetProjectNameOptions,
  GetSOObjectiveOptions,
  GetOpportunityIntentOptions,
  GetSolutionAreasByAreaPath,
  GetMeetingTypeOriginByAreaPath,
  GetOperatingUnit,
  GetReferredToOptions,
  GetHelpNeededApexOptions,
  GetCustomerEngagementActivityOptions,
  GetCollabAppsContestOptions,
  GetNonRecurringValues,
  GetLogicalOperators,
  GetBusinessDivisionOptions,
  GetRolesImpactedOptions,
  GetProcessOrToolsImpactedOptions,
  GetIntakeOptions,
  GetExecutingTeamNameOptions,
  GetProblemTypeOptions,
  GetStrategicCategoryOptions,
  GetL1BusinessProcessOptions,
  GetL2BusinessProcessOptions,
  GetL3BusinessProcessOptions,
  GetCloudImpacted,
  GetRequestTypeOptions,
  GetNominationTypeValues,
  GetRBAreaOptions,
  GetRegionOptions,
  GetCountryOptions,
  GetTechnologyOptions,
  GetTicketReasonOptions,
  GetGeneralCategoryOptions,
  GetCloudVsOnpremOptions,
  GetTimezoneValues,
  GetRequestTypeValues,
  GetModelValues,
  GetPreferredRegionValues,
  GetDecisionValues,
  GetTypeOfFunds,
  GetActivityTypes,
  GetDeliveryMethodValues,
  GetEntityTypeValues,
  GetProgramName,
  GetMaaSRequestTypeOptions,
  GetMaaSRoleOptions,
  GetMaaSOUOptions,
  GetMaaSMCEMOptions,
  GetMaaSIndustryOptions,
  GetMaaSSegmentOptions,
  GetMaaSSubRoleOptions,
  GetMaaSSubRoleOptionsByRole,
  GetMaaSAreaOptions,
  GetMaaSMaaSIsExistingAccOptions,
  GetMaaSExistingAccountValues,
  GetReasonForExceptionOptions,
  GetStageOptions,
  GPSInvestmentComplexity,
  GetGPSBusinessOptions,
  GetGPSDiscussionOptions,
  GetGPSFundingSourceOptions,
  GetGPSFundingTypeOptions,
  GetGPSInvestmentTypeOptions,
  GetGPSPIRDecisionOptions,
  GetGPSPartnerOptions,
  GetGPSProductOptions,
  GetGPSRequestTypeOptions,
  GetMaaSSubSegementOptions,
  GetAMMAaofertypeOptions,
  GetAMMActionTakenOptions,
  GetAMMAzureFutureGrowthOfferOptions,
  GetAMMCancellationReasonOptions,
  GetAMMCommunicationPreferenceOptions,
  GetAMMCustomerCommitmentToStartOptions,
  GetAMMDealStructureOptions,
  GetAMMDisqualificationReasonOptions,
  GetAMMDoYouWantToRequestAcoInAdditionToEcifOptions,
  GetAMMECIFFutureGrowthOfferOptions,
  GetAMMEsiOptions,
  GetAMMFinacialYearOptions,
  GetAMMFtaOptions,
  GetAMMHelpTypeOptions,
  GetAMMMicrosoftdefenderforcloudOptions,
  GetAMMMigrationPartnerAttachedOptions,
  GetAMMNextBestActionOptions,
  GetAMMOfferEnginestatusOptions,
  GetAMMOfferEngineTypeOptions,
  GetAMMOfferOptions,
  GetAMMPendingactionfromnOptions,
  GetAMMPreOrPostOptions,
  GetAMMPrimarySolutionOptions,
  GetAMMProgramOptions,
  GetAMMRejectionReasonOptions,
  GetAMMRequestReasonOptions,
  GetAMMRequestTypeOptions,
  GetAMMSAPOfferOptions,
  GetAMMScopeOfWorkOptions,
  GetAMMServiceLocationOptions,
  GetAMMSupportRegionOptions,
  GetAMMSupportedScenarioOptions,
  GetAMMTypeOfFundingNeededOptions,
  GetAMMWillThisRequestRequireAdditionalAttendeesOptions,
  GetAMMYesOrNoOptions,
  GetPrimaryAzureVirtualMachineOptions,
  GetECIFApprovedOrRejected,
  GetECIFDealStructure,
  GetECIFRequestReason,
  GetAMMOfferDeskRegionOptions,
  GetDealTypeValues,
  GetDwrRecommendationValues,
} from '../Common/Models/DropdownConstants';
import {
  UATConstants,
  HttpVerbs,
  CustomTextForCompare,
  formatDate,
} from 'src/Common/Models/UATConstants';
import { ServiceFactoryClientExecuteApi } from 'src/Common/Services/ServiceFactoryToExecuteApi';
import ErrorResponse from 'src/Models/ErrorResponse';
import {
  GetSubStateOptions,
  GetCSGProducts,
  GetStatus,
  GetIntentToMoveTocloud,
  GetIfNoStateReason,
  GetInterestedInOtherECIF,
  GetIfYesStateReason,
} from 'src/Common/Models/DropdownConstants';
import {
  GetPrograms,
  GetApplication,
  GetEcifStatus,
  GetRequestedServiceStatus,
  GetInterestInAssessment,
  GetAssesmentType,
  GetMigrationType,
  GetPatner,
  GetEcifStatusIfCma,
} from 'src/Common/Models/DropdownConstants';
import {
  GetInterestedInRenewing,
  GetAssesmentServiceStatus,
} from 'src/Common/Models/DropdownConstants';
import { checkForUngroup } from '../actions/ViewActions';
import { connect } from 'react-redux';
import { IBannerMessagePayload } from 'src/Common/Models/BannerMessage';
import { setBanner } from 'src/actions/BannerMessage';
import { sanitizeText } from 'src/utils/utils';
import { compact, uniq } from 'lodash-es';
import { CustomDropdown } from 'src/Common/Components/CustomDropdown';
import { UserContact, UserManager } from 'src/Models/UserProfile';
import { GetUserPersona } from '../dashboard/ShowCard';
import UserCard from 'src/Common/Components/UserCard';
import { FieldFilter } from './AnalyticsModel';
import { AnalyticsActions } from './AnalyticsActions';
import moment from 'moment';
import { ErrorMessage } from 'src/App/Components/Common/ErrorMessage';
import SimpleDropdown from 'src/Common/Components/SimpleDropdown';
import { MACCConstants } from 'src/Common/Models/MaccConst';

export interface ICustomFilterItemState {
  logicalOperatorDisabled: boolean;
  logicalOperator: LogicalOperator[];
  logicalOperatorOptions: IDropdownOption[];
  selectedLogicalOperatorId: number;
  selectedLogicalOperator: string;
  selectedField: string;
  selectedFieldReference: string;
  sqlOperator: SQLOperator[];
  sqlOptions: IDropdownOption[];
  selectedSQLOperatorId: any;
  selectedSQLOperator: string;
  fieldValue: FieldValue[];
  fieldValueOptions: IDropdownOption[];
  selectedFieldValueIds: any;
  selectedFieldValues: string[];
  queryGroup: FieldFilter;
  isIdentity: boolean;
  isPicklist: boolean;
  isDate: boolean;
  isMultiSelect: boolean;
  isNumber: boolean;
  isDecimal: boolean;
  isChecked: boolean;
  isBoolean: boolean;
  isFieldValid: boolean;
  isValueValid: boolean;
  assignToCorpField: boolean;
  isCompareField: boolean;
  isIdLists: boolean;
  isGroupOperator: boolean;
  userContactDetails: UserContact;
  userManager: UserManager;
  error: string;
  managerAlias: string;
  isCalloutVisible: boolean;
  buttonId: string;
  onDismissFocus: boolean;
  isTags: boolean;
  tagOptions: IDropdownOption[];
  selectedDate: Date;
  toggleValue: boolean;
  isAreaPathOrIteration: boolean;
}

export interface ICustomFilterItemProps {
  fieldOptions: any[];
  queryItem: FieldFilter;
  queryItemIndex: number;
  onDelete: Function;
  updateParentList: Function;
  assignedTeam: any[];
  setBanner: Function;
  tagsOptions: any[];
}

class AnalyticsFilterItem extends React.Component<ICustomFilterItemProps, ICustomFilterItemState> {
  constructor(props: ICustomFilterItemProps) {
    super(props);
    this.state = {
      logicalOperatorDisabled: false,
      logicalOperator: [],
      logicalOperatorOptions: [],
      selectedLogicalOperatorId: 0,
      selectedLogicalOperator: 'And',
      selectedField: '',
      selectedFieldReference: '',
      sqlOperator: [],
      sqlOptions: [],
      selectedSQLOperatorId: this.props.queryItem.fieldOperation,
      selectedSQLOperator:
        GetSQLOperators().find((x) => x.id === this.props.queryItem.fieldOperation)?.sqlOperator ||
        '',
      fieldValue: [],
      fieldValueOptions: [],
      selectedFieldValueIds: [],
      selectedFieldValues: [],
      queryGroup: props.queryItem,
      isIdentity: false,
      isNumber: false,
      isDecimal: false,
      isBoolean: false,
      isPicklist: false,
      isDate: false,
      isChecked: false,
      isMultiSelect: false,
      isFieldValid: false,
      isValueValid: true,
      isCompareField: false,
      assignToCorpField: false,
      isIdLists: false,
      isGroupOperator: false,
      userContactDetails: new UserContact(),
      userManager: new UserManager(),
      error: '',
      managerAlias: '',
      isCalloutVisible: false,
      buttonId: 'callout-button',
      onDismissFocus: false,
      isTags: false,
      tagOptions: [],
      selectedDate: new Date(),
      toggleValue: false,
      isAreaPathOrIteration: false,
    };
    this.getLogicalOperators = this.getLogicalOperators.bind(this);
    this.getFiledValues = this.getFiledValues.bind(this);
    this.getADOTags = this.getADOTags.bind(this);
  }

  componentDidMount() {
    this.getLogicalOperators();
    this.getFiledValues();
    if (this.props.fieldOptions.length > 0) {
      this.onFieldChange2(null, {
        key: this.state.queryGroup.fieldName,
        text: this.state.queryGroup.fieldDisplayName,
      });
    }
  }

  private getLogicalOperators = () => {
    const options: IDropdownOption[] = [];
    const logicalOperators = GetLogicalOperators();
    logicalOperators.forEach((item: LogicalOperator) => {
      options.push({
        key: item.id,
        text: item.logicalOperator,
      });
    });
    this.setState({
      logicalOperatorOptions: options,
      logicalOperator: logicalOperators,
    });
  };

  private isComponentValid = () => {
    const isValid = this.state.isFieldValid && this.state.isValueValid;
    return isValid;
  };

  private validate = () => {
    this.isComponentValid();
  };

  private getSQLOperatorsFromField = (fieldOption: any) => {
    const options: IDropdownOption[] = [];
    const sqlOperators = this.GetSupportedOperationByField(fieldOption);
    sqlOperators.forEach((item: SQLOperator) => {
      options.push({
        key: item.id,
        text: item.sqlOperator,
      });
    });
    let findOperator = options.find((x) => x.key === this.props.queryItem.fieldOperation);
    if (!findOperator) {
      //1-by default we get this.props.queryItem.clause.operator.operatorInternalName value as "="
      //2-for few fields(eg Description) "=" operator is NOT applicable
      findOperator = options[0];
      //3-we need to update new operator value in parent so we are calling below method
    }

    this.setState({
      sqlOptions: options,
      sqlOperator: sqlOperators,
      selectedSQLOperatorId: findOperator.key,
      selectedSQLOperator: findOperator.text,
    });
    return findOperator.key;
  };

  private GetSupportedOperationByField = (fieldOption: any) => {
    let fieldTypeOperators: number[] = [];

    //Maping of the Operators
    if (fieldOption.isNumber) fieldTypeOperators = [0, 1, 2, 3, 4, 5];
    else if (fieldOption.isPicklist) fieldTypeOperators = [0, 1];
    else if (fieldOption.isDate) fieldTypeOperators = [0, 1, 2, 3, 4, 5];
    else if (fieldOption.isDecimal) fieldTypeOperators = [0, 1];
    else if (fieldOption.isIdentity) fieldTypeOperators = [0, 1];
    else if (fieldOption.isTags) fieldTypeOperators = [6, 7];
    else if (fieldOption.isAreaPathOrIteration) fieldTypeOperators = [8, 9, 0, 1];
    else fieldTypeOperators = [0, 1];

    const sqlOperators = AnalyticsActions.GetSQLOperators();
    const supportedOperations: SQLOperator[] = [];
    sqlOperators.forEach((item: SQLOperator) => {
      if (fieldTypeOperators.includes(item.id)) {
        supportedOperations.push({
          id: item.id,
          sqlOperator: item.sqlOperator,
        });
      }
    });
    return supportedOperations;
  };

  private getFiledValues = () => {
    const options: IDropdownOption[] = [];
    const fieldValues = GetFieldValues();
    fieldValues.forEach((item: FieldValue) => {
      options.push({
        key: item.id,
        text: item.fieldValueName,
      });
    });
    this.setState({
      fieldValueOptions: options,
      fieldValue: fieldValues,
    });
  };

  private onFieldChange = (option: IDropdownOption) => {
    if (option !== undefined) {
      const selectedId = option.key as string;
      const propObj = this.props.fieldOptions.find((x) => x.key === selectedId);
      if (propObj !== undefined) {
        let isValid = false;
        const clause: FieldFilter = { ...this.state.queryGroup };
        clause.fieldDisplayName = option.text;
        clause.fieldName = selectedId;
        clause.value.values = [];
        isValid = true;

        if (
          propObj.type === 'Edm.String' &&
          !propObj.isTags &&
          !propObj.isPicklist &&
          !propObj.isAreaPathOrIteration
        ) {
          AnalyticsActions.GetAnalyticsViewFieldValues(option.text, (val: string[]) => {
            const fieldValueOptions1 = val.map((item: string) => ({
              key: item,
              text: item,
            }));

            this.setState({
              fieldValueOptions: fieldValueOptions1,
              isPicklist: val.length > 0,
            });
          });
        }

        const initFieldOperator = this.getSQLOperatorsFromField(propObj);
        clause.fieldOperation = parseInt(initFieldOperator.toString());
        this.setState(
          {
            queryGroup: clause,
            selectedField: option.text,
            selectedFieldReference: propObj.propertyName,
            isIdentity: propObj.isIdentity,
            isNumber: propObj.isNumber,
            isDecimal: propObj.isDecimal,
            isBoolean: propObj.isBoolean,
            isPicklist: propObj.isPicklist,
            isDate: propObj.isDate,
            isFieldValid: isValid,
            isMultiSelect: selectedId === 'TagNames',
            selectedFieldValueIds: [],
            selectedFieldValues: [],
            isTags: selectedId === 'TagNames',
            fieldValueOptions: [],
            isAreaPathOrIteration: propObj.isAreaPathOrIteration,
          },
          () => {
            this.props.updateParentList(this.state.queryGroup);
            propObj.isDate && this.onDateFieldValueChange(new Date());
            this.validate();
          }
        );

        this.setDropdownValuesByOperator(propObj);
      }
    }
  };

  private onFieldChange2 = (event: any, option: IDropdownOption) => {
    let isValid = false;
    if (option !== undefined) {
      const selectedId = option.key as string;
      const propObj = this.props.fieldOptions.find((x) => x.key === selectedId);
      const groupClauseValue = '';
      if (propObj !== undefined) {
        const clause: FieldFilter = { ...this.state.queryGroup };
        isValid = true;

        this.setState({
          selectedField: option.text,
          selectedFieldReference: propObj.propertyName,
          isIdentity: propObj.isIdentity,
          isNumber: propObj.isNumber,
          isDecimal: propObj.isDecimal,
          isBoolean: propObj.isBoolean,
          isPicklist: propObj.isPicklist,
          isDate: propObj.isDate,
          isFieldValid: isValid,
          isMultiSelect: selectedId === 'TagNames',
          isTags: selectedId === 'TagNames',
          selectedFieldValueIds: selectedId === 'TagNames' ? [] : clause.value.values,
          selectedFieldValues: selectedId === 'TagNames' ? [] : clause.value.values,
          isAreaPathOrIteration: selectedId === 'Area/AreaPath',
          selectedLogicalOperatorId: clause.value.operator,
          selectedLogicalOperator: clause.value.operator === 1 ? 'Or' : 'And',
        });

        if (
          propObj.type === 'Edm.String' &&
          !propObj.isPicklist &&
          selectedId !== 'TagNames' &&
          selectedId !== 'Area/AreaPath'
        ) {
          AnalyticsActions.GetAnalyticsViewFieldValues(option.text, (val: string[]) => {
            const fieldValueOptions1 = val.map((item: string) => ({
              key: item,
              text: item,
            }));

            this.setState({
              fieldValueOptions: fieldValueOptions1,
              isPicklist: val.length > 0,
            });
          });
        }
        this.getSQLOperatorsFromField(propObj);
      }
      this.setDropdownValuesByOperator2(propObj, groupClauseValue);
    }
  };
  setDropdownValuesByOperator2(propObj: any, prop2: string = '') {
    if (propObj !== undefined) {
      if (propObj.isPicklist) {
        this.selectedFieldOption(propObj.referenceName);
      } else if (propObj.isIdentity) {
        const selectedFieldValueIdList = [];
        const selectedFieldValues = [];
        for (const i in this.props.queryItem.value.values) {
          if (prop2) {
            selectedFieldValueIdList.push(
              this.props.queryItem.value.values[i].slice(
                0,
                this.props.queryItem.value.values[i].indexOf(
                  UATConstants.groupOperatorKeywordADOQuery
                )
              )
            );
          } else {
            selectedFieldValueIdList.push(this.props.queryItem.value.values[i]);
          }
          selectedFieldValues.push(this.props.queryItem.value.values[i]);
        }
        this.setState({
          selectedFieldValueIds: selectedFieldValueIdList,
          selectedFieldValues: selectedFieldValues,
        });
      } else if (propObj.isDate === 2) {
        this.setState({
          selectedFieldValueIds: this.props.queryItem.value.values,
          selectedFieldValues: this.props.queryItem.value.values,
        });
      } else if (propObj.isDate) {
        this.setState({
          selectedDate: moment.utc(this.props.queryItem.value.values[0]).toDate(),
        });
      } else if (propObj.isBoolean) {
        this.setState({
          toggleValue: this.props.queryItem.value.values[0] === 'true',
        });
      } else if (propObj.isNumber) {
        const numberVal = this.props.queryItem.value.values[0];
        if (numberVal !== '') {
          if (parseInt(numberVal).toString() === numberVal) {
            this.setState({ isValueValid: true });
          } else {
            this.setState({ isValueValid: false });
          }
        }
        this.setState({
          selectedFieldValues: [this.props.queryItem.value.values.join(',')],
        });
      } else if (propObj.isDecimal) {
        const numberVal = this.props.queryItem.value.values[0];
        if (numberVal !== '') {
          const regex = /^\d+(\.\d{1,2})?$/;
          if (regex.test(numberVal)) {
            this.setState({ isValueValid: true });
          } else {
            this.setState({ isValueValid: false });
          }
        }
        this.setState({
          selectedFieldValues: [this.props.queryItem.value.values.join(',')],
        });
      } else if (propObj.isTags) {
        this.setTagsCombobox();
      } else if (propObj.isAreaPathOrIteration) {
        this.setAreaPathCombobox();
      } else if (!UATConstants.MultiselectOperators.includes(this.state.selectedSQLOperator)) {
        this.setState({
          selectedFieldValues: this.props.queryItem.value.values,
        });
      } else {
        this.setState({
          selectedFieldValues: [this.props.queryItem.value.values.join(',')],
        });
      }
    }
  }
  setDropdownValuesByOperator(propObj: any) {
    if (propObj.isPicklist || propObj.isAreaPathOrIteration || propObj.isTags) {
      this.selectedFieldOption(propObj.referenceName);
    }
  }

  setTagsCombobox = () => {
    this.selectedFieldOption('TagNames');
  };

  setAreaPathCombobox = () => {
    this.selectedFieldOption('Area/AreaPath');
  };

  private selectedFieldOption(selectedItem: string) {
    //Replace "Custom_" with .
    let selectedFieldText = selectedItem;

    if (selectedFieldText.startsWith('Custom_'))
      selectedFieldText = selectedItem.replace('Custom_', 'Custom.');
    else if (selectedFieldText === 'TagNames') selectedFieldText = UATConstants.UATFields.Tags;
    else selectedFieldText = 'System.' + selectedItem;

    switch (selectedFieldText) {
      case UATConstants.UATFields.SolutionArea:
        this.updateFieldValues(GetSolutionAreas(), 'solutionArea');
        break;
      case UATConstants.UATFields.State:
        this.updateFieldValues(GetWorkItemStates(), 'Name', 'state');
        break;
      case UATConstants.UATFields.AreaField:
        this.updateFieldValues(GetAreas(), 'area');
        break;
      case UATConstants.UATFields.MilestoneStatus:
        this.updateFieldValues(GetMilestoneStatusOptions(), 'mileStoneStatus');
        break;
      case UATConstants.UATFields.SubState:
        this.updateFieldValues(GetSubStateOptions(), 'subState');
        break;
      case UATConstants.UATFields.CSGProducts:
        this.updateFieldValues(GetCSGProducts(), 'csgProductList');
        break;
      case UATConstants.UATFields.Status:
        this.updateFieldValues(GetStatus(), 'status');
        break;
      case UATConstants.UATFields.IntenttomovetoCloud:
        this.updateFieldValues(GetIntentToMoveTocloud(), 'intentToMoveToCloud');
        break;
      case UATConstants.UATFields.InterestedinotherECIF:
        this.updateFieldValues(GetInterestedInOtherECIF(), 'interestedInOtherECIF');
        break;
      case UATConstants.UATFields.ifNoStateReason:
        this.updateFieldValues(GetIfNoStateReason(), 'ifNoStateReason');
        break;
      case UATConstants.UATFields.ECIFReason:
        this.updateFieldValues(GetIfYesStateReason(), 'ifYesStateReason');
        break;
      case UATConstants.UATFields.Program:
        this.updateFieldValues(GetPrograms(), 'program');
        break;
      case UATConstants.UATFields.Application:
        this.updateFieldValues(GetApplication(), 'name');
        break;
      case UATConstants.UATFields.ECIFStatus:
        this.updateFieldValues(GetEcifStatus(), 'ecifStatus');
        break;
      case UATConstants.UATFields.ECIFrequestedservicestatus:
        this.updateFieldValues(GetRequestedServiceStatus(), 'ecifRequestedServiceStatus');
        break;
      case UATConstants.UATFields.InterestedinAssessment:
        this.updateFieldValues(GetInterestInAssessment(), 'interestedInAssessment');
        break;
      case UATConstants.UATFields.AssessmentType:
        this.updateFieldValues(GetAssesmentType(), 'assesmentType');
        break;
      case UATConstants.UATFields.MigrationType:
        this.updateFieldValues(GetMigrationType(), 'migrationType');
        break;
      case UATConstants.UATFields.Partner:
        this.updateFieldValues(GetPatner(), 'partner');
        break;
      case UATConstants.UATFields.ECIFstatusifCMA:
        this.updateFieldValues(GetEcifStatusIfCma(), 'ecifStatusIfCMA');
        break;
      case UATConstants.UATFields.InterestedinrenewingBREPorSA:
        this.updateFieldValues(GetInterestedInRenewing(), 'interestedInRenewing');
        break;
      case UATConstants.UATFields.AssessmentStatus:
        this.updateFieldValues(GetAssesmentServiceStatus(), 'assesmentServiceStatus');
        break;
      case UATConstants.UATFields.ScopeValue:
        this.updateFieldValues(GetScopeOldOptions(), 'scopeOld');
        break;
      case UATConstants.UATFields.FY:
        this.updateFieldValues(GetFinancialYearOptions(), 'fy');
        break;
      case UATConstants.UATFields.Quarter:
        this.updateFieldValues(GetQuarterOptions(), 'quarter');
        break;
      case UATConstants.UATFields.QBCTop5Ask:
        this.updateFieldValues(GetTop5AskOptions(), 'qbcTop5Ask');
        break;
      case UATConstants.UATFields.AzurePriority:
        this.updateFieldValues(GetAzurePriorityOptions(), 'azurePriority');
        break;
      case UATConstants.UATFields.TopicCategory:
        this.updateFieldValues(GetTopicCategoryOptions(), 'topicCategory');
        break;
      case UATConstants.UATFields.Organization:
        this.updateFieldValues(GetOrgOptions(), 'organization');
        break;
      case UATConstants.UATFields.FeedbackType:
        this.updateFieldValues(GetFeedbackTypeOptions(), 'feedbackType');
        break;
      case UATConstants.UATFields.TriageValue:
        this.updateFieldValues(GetTriageValues(), 'triage');
        break;
      case UATConstants.UATFields.EngContactvalue:
        this.updateFieldValues(GetEngineeringContactValues(), 'engineeringContact');
        break;
      case UATConstants.UATFields.EngStatusValue:
        this.updateFieldValues(GetEngineeringStatus(), 'engineeringStatus');
        break;
      case UATConstants.UATFields.ActionCategoryField:
        this.updateFieldValues(GetActionCategories(), 'actionCategory');
        break;
      case UATConstants.UATFields.ActionPriorityField:
        this.updateFieldValues(GetPriorityOptions(), 'actionPriority');
        break;
      case UATConstants.UATFields.EOU:
        this.updateFieldValues(GetEOUS(), 'eou');
        break;
      case UATConstants.UATFields.Industry:
        this.updateFieldValues(GetIndustryOptions(), 'industry');
        break;
      case UATConstants.UATFields.customIndustry:
        this.updateFieldValues(GetCustomIndustryOptions(), 'customIndustry');
        break;
      case UATConstants.UATFields.PatternGroupName:
        this.updateFieldValues(GetPatternGroup(), 'patternGroup');
        break;
      case UATConstants.UATFields.MilestoneReason:
        this.updateFieldValues(GetMilestoneReason(), 'milestoneReason');
        break;
      case UATConstants.UATFields.MilestoneWorkload:
        this.updateFieldValues(GetMilestoneWorkloadOptions(), 'milestoneWorkload');
        break;
      case UATConstants.UATFields.HelpNeededField:
        this.updateFieldValues(GetHelpNeededOptions(), 'helpNeeded');
        break;
      case UATConstants.UATFields.TestSuitType:
        this.updateFieldValues(GetTestSuitType(), 'testSuitType');
        break;
      case UATConstants.UATFields.AutomationStatus:
        this.updateFieldValues(GetAutomationStatus(), 'automationStatus');
        break;
      case UATConstants.UATFields.StateCode:
        this.updateFieldValues(GetStateCode(), 'stateCode');
        break;
      case UATConstants.UATFields.ClosedStatus:
        this.updateFieldValues(GetClosedStatus(), 'closedStatus');
        break;
      case UATConstants.UATFields.ClosedStatusCode:
        this.updateFieldValues(GetClosedStatusCode(), 'closedStatusCode');
        break;
      case UATConstants.UATFields.IsBlocked:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse');
        break;
      case UATConstants.UATFields.OneListFeedback:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse', 'onelistfeedback');
        break;
      case UATConstants.UATFields.FeatureParityRequest:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse', 'featureParityRequest');
        break;
      case UATConstants.UATFields.Priority:
        this.updateFieldValues(GetPriorityOptions(), 'priority');
        break;
      case UATConstants.UATFields.Rating:
        this.updateFieldValues(GetRating(), 'rating');
        break;
      case UATConstants.UATFields.Severity:
        this.updateFieldValues(GetSeverity(), 'severity');
        break;
      case UATConstants.UATFields.SyncWithCE:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse');
        break;
      case UATConstants.UATFields.WorkItemType:
        this.updateFieldValues(GetWorkItemType(), 'workItemType');
        break;
      case UATConstants.UATFields.BoardColumn: //values r not loading in ui
        this.updateFieldValues(GetBoardColumn(), 'boardColumn');
        break;
      case UATConstants.UATFields.BoardColumnDone:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse');
        break;
      case UATConstants.UATFields.ValueArea:
        this.updateFieldValues(GetValueArea(), 'valueArea');
        break;
      case UATConstants.UATFields.Tags:
        this.getADOTags();
        break;
      case UATConstants.AssignToCorp:
        this.updateFieldValues(GetAssignedToCorpValues(), 'assignToCorp');
        break;
      case UATConstants.UATFields.NonRecurring:
        this.updateFieldValues(GetNonRecurringValues(), 'nonRecurring');
        break;
      case UATConstants.UATFields.CloudIntentreason:
        this.updateFieldValues(GetCloudIntentreason(), 'cloudIntentreason');
        break;
      case UATConstants.UATFields.Completionstatusifcombined:
        this.updateFieldValues(GetCompletionStatusIfCombined(), 'compleationStatusIfCombined');
        break;
      case UATConstants.UATFields.Escalated:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse');
        break;
      case UATConstants.UATFields.MeetingTypeOrigin:
        this.updateFieldValues(GetMeetingTypeOrigin(), 'meetingTypeOrigin');

        break;
      case UATConstants.UATFields.MeetingSubType:
        this.updateFieldValues(GetMeetingSubTypes(), 'meetingSubType');
        break;
      case UATConstants.UATFields.Nonrenewingreason:
        this.updateFieldValues(GetNonRenewingReason(), 'nonRenewingReason');
        break;
      case UATConstants.UATFields.PubliclyDocumented:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse');
        break;
      case UATConstants.UATFields.WorkloadType:
        this.updateFieldValues(GetWorkloadType(), 'workloadType');
        break;
      case UATConstants.UATFields.Issue:
        this.updateFieldValues(GetIssue(), 'issue');
        break;
      case UATConstants.UATFields.Activity:
        this.updateFieldValues(GetActivity(), 'activity');
        break;
      case UATConstants.UATFields.FoundIn:
        this.updateFieldValues(GetFoundIn(), 'foundIn');
        break;
      case UATConstants.UATFields.IntegrationBuild:
        this.updateFieldValues(GetIntegrationBuild(), 'integrationBuild');
        break;
      case UATConstants.UATFields.Blocked:
        this.updateFieldValues(GetYesOrNo(), 'yesOrNo');
        break;
      case UATConstants.UATFields.AssistedMigrationReason:
        this.updateFieldValues(GetAssistedMigrationreason(), 'assistedMigrationReason');
        break;
      case UATConstants.UATFields.Reason:
        this.updateFieldValues(GetReason(), 'reason');
        break;
      case UATConstants.UATFields.IsCovid19:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse', 'isCovid');
        break;
      case UATConstants.UATFields.IsitFAM:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse');
        break;
      case 'System.Iteration/IterationPath':
        this.updateFieldValues(GetIterationPath(), 'iterationPath');
        break;
      case 'System.Area/AreaPath':
        this.updateFieldValues(this.props.assignedTeam, 'areaPathCustom');
        break;
      case UATConstants.UATFields.Theme:
        this.updateFieldValues(GetThemeOptions(), 'theme');
        break;
      case UATConstants.UATFields.CAEEngagementCategory:
        this.updateFieldValues(GetEngagementCategoryOptions(), 'engagementCategory');
        break;
      case UATConstants.UATFields.CAEEngagementRegion:
        this.updateFieldValues(GetEngagementRegionOptions(), 'engagementRegion');
        break;
      case UATConstants.UATFields.CAEScenarioCohort:
        this.updateFieldValues(GetScenarioCohortOptions(), 'scenarioCohort');
        break;
      case UATConstants.UATFields.CAEFirstPartyOffering:
        this.updateFieldValues(GetFirstPartyOfferingOptions(), 'firstPartyOffering');
        break;
      case UATConstants.UATFields.CAEFirstPartySolution:
        this.updateFieldValues(GetFirstPartySolutionOptions(), 'firstPartySolution');
        break;
      case UATConstants.UATFields.CAEThirdPartySolution:
        this.updateFieldValues(GetThirdPartySolutionOptions(), 'thirdPartySolution');
        break;
      case UATConstants.UATFields.LTEscalation:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse');
        break;
      case UATConstants.UATFields.AdditionalTheme:
        this.updateFieldValues(GetAdditionalTheme(), 'additionalTheme');
        break;
      //adding new fields which was in ignoredList Before
      case UATConstants.UATFields.AssociatedContextType:
        this.updateFieldValues(GetAssociatedType(), 'associatedContextType');
        break;
      case UATConstants.UATFields.MeetingsPitchDeck:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse');
        break;
      case UATConstants.UATFields.MeetingsWorkshop:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse');
        break;
      case UATConstants.UATFields.TCOAnalysis:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse');
        break;
      case UATConstants.UATFields.POCECIFConsumption:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse');
        break;
      case UATConstants.UATFields.SubmittedforAWR:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse');
        break;
      case CustomTextForCompare.dateType:
        this.updateFieldValues(GetDateValues(), 'dateSelectionFormat');
        break;
      case UATConstants.UATFields.ActionType:
        this.updateFieldValues(GetActionType(), 'actionType');
        break;
      case UATConstants.UATFields.InterestedinAssistedMigration:
        this.updateFieldValues(
          GetInterestedAssistedMigrationreason(),
          'interestedAssistedMigrationreason'
        );
        break;
      case UATConstants.UATFields.ServiceTreeOffering:
        this.updateFieldValues(GetServiceTreeOffering(), 'serviceTreeOffering');
        break;
      case UATConstants.UATFields.ServiceTreeOffering2:
        this.updateFieldValues(GetServiceTreeOffering2(), 'serviceTreeOffering');
        break;
      case UATConstants.UATFields.ServiceTreeOffering3:
        this.updateFieldValues(GetServiceTreeOffering3(), 'serviceTreeOffering');
        break;
      case UATConstants.UATFields.BusinessProposal:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse');
        break;
      case UATConstants.UATFields.ECIFstatusforFAM:
        this.updateFieldValues(GetEcifStatusIfFam(), 'ecifStatusFAM');
        break;
      case UATConstants.UATFields.ApplicationType:
        this.updateFieldValues(GetApplicationType(), 'applicationType');
        break;
      case UATConstants.UATFields.OfferRelated:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse');
        break;
      case UATConstants.UATFields.SolutionAreaList:
        this.updateFieldValues(GetSolutionAreas(), 'solutionArea');

        break;
      case CustomTextForCompare.Id:
        this.updateFieldValues(GetIdInValues(), 'valueIn');
        break;
      case UATConstants.UATFields.HelpNeededOpportunity:
        this.updateFieldValues(
          GetHelpNeededOpportunityOptions(),
          'helpNeeded',
          'helpNeededOpportunity'
        );
        break;
      case UATConstants.UATFields.DeliveryBlockers:
        this.updateFieldValues(GetDeliveryBlockers(), 'deliveryBlocker');
        break;
      case UATConstants.UATFields.AdditionalArea:
        this.updateFieldValues(GetAreas(), 'area');
        break;
      case UATConstants.UATFields.AdditionaEOU:
        this.updateFieldValues(GetEOUS(), 'eou');
        break;
      case UATConstants.UATFields.OpportunityStatus:
        this.updateFieldValues(GetOpportunityStatusOptions(), 'opportunityStatus', 'Outcome');
        break;
      case UATConstants.UATFields.OpportunityIntent:
        this.updateFieldValues(GetOpportunityIntentOptions(), 'opportunityIntent');
        break;
      case UATConstants.UATFields.ListeningCircleArea:
        this.updateFieldValues(GetAreas(), 'area');
        break;
      case UATConstants.UATFields.ProjectName:
        this.updateFieldValues(GetProjectNameOptions(), 'projectName');
        break;
      case UATConstants.UATFields.SOObjective:
        this.updateFieldValues(GetSOObjectiveOptions(), 'SOObjective');
        break;
      case UATConstants.UATFields.OperatingUnitList:
        this.updateFieldValues(GetOperatingUnit(), 'operatingUnit');
        break;
      case UATConstants.UATFields.CloudImpactedList:
        this.updateFieldValues(GetCloudImpacted(), 'cloudImpacted');
        break;
      case UATConstants.UATFields.ReferredTo:
        this.updateFieldValues(GetReferredToOptions(), 'referredTo');
        break;
      case UATConstants.UATFields.HelpNeededApex:
        this.updateFieldValues(GetHelpNeededApexOptions(), 'helpNeeded');
        break;
      case UATConstants.UATFields.WhenDoesCustomerWantToEngage:
        this.updateFieldValues(
          GetCustomerEngagementActivityOptions(),
          'customerEngagementActivity'
        );
        break;
      case UATConstants.UATFields.PartOfCollabAppsContent:
        this.updateFieldValues(GetCollabAppsContestOptions(), 'collabAppsContest');
        break;
      case UATConstants.UATFields.ITandBusinessStakeholders:
        this.updateFieldValues(GetYesOrNo(), 'yesOrNo');
        break;
      case UATConstants.UATFields.ExecutiveSponsor:
        this.updateFieldValues(GetYesOrNo(), 'yesOrNo');
        break;
      case UATConstants.UATFields.BusinessDivision:
        this.updateFieldValues(GetBusinessDivisionOptions(), 'businessDivision');
        break;
      case UATConstants.UATFields.RolesImpacted:
        this.updateFieldValues(GetRolesImpactedOptions(), 'rolesImpacted');
        break;
      case UATConstants.UATFields.ToolsImpacted:
        this.updateFieldValues(GetProcessOrToolsImpactedOptions(), 'toolsImpacted');
        break;
      case UATConstants.UATFields.IntakeType:
        this.updateFieldValues(GetIntakeOptions(), 'intake');
        break;
      case UATConstants.UATFields.ProblemType:
        this.updateFieldValues(GetProblemTypeOptions(), 'problemType');
        break;
      case UATConstants.UATFields.StrategicCategory:
        this.updateFieldValues(GetStrategicCategoryOptions(), 'strategicCategory');
        break;
      case UATConstants.UATFields.L1BusinessProcess:
        this.updateFieldValues(GetL1BusinessProcessOptions(), 'bpaL1');
        break;
      case UATConstants.UATFields.L2BusinessProcess:
        this.updateFieldValues(GetL2BusinessProcessOptions(), 'bpaL2');
        break;
      case UATConstants.UATFields.L3BusinessProcess:
        this.updateFieldValues(GetL3BusinessProcessOptions(), 'bpaL3');
        break;
      case UATConstants.UATFields.ExecutingTeamName:
        this.updateFieldValues(GetExecutingTeamNameOptions(), 'executingTeamName');
        break;
      case UATConstants.UATFields.RequestType:
        this.updateFieldValues(GetRequestTypeOptions(), 'requestType');
        break;
      case UATConstants.UATFields.AOAIDealType:
        this.updateFieldValues(GetDealTypeValues(), 'dealType');
        break;
      case UATConstants.UATFields.ApexPartnerEngage:
        this.updateFieldValues(GetYesOrNo(), 'yesOrNo');
        break;
      case UATConstants.UATFields.AOAI_Timezone:
        this.updateFieldValues(GetTimezoneValues(), 'timezone');
        break;
      case UATConstants.UATFields.AOAIRequestedType:
        this.updateFieldValues(GetRequestTypeValues(), 'requestType');
        break;
      case UATConstants.UATFields.AOAI_Model:
        this.updateFieldValues(GetModelValues(), 'aoaiModel');
        break;
      case UATConstants.UATFields.AOAI_IsRecommendedForDWR:
        this.updateFieldValues(GetDwrRecommendationValues(), 'aoaiDwrRecommendation');
        break;
      case UATConstants.UATFields.AOAI_PreferredRegion:
        this.updateFieldValues(GetPreferredRegionValues(), 'preferredRegion');
        break;
      case UATConstants.UATFields.AOAI_Decision:
        this.updateFieldValues(GetDecisionValues(), 'decision');
        break;
      case UATConstants.UATFields.AOAI_ApprovedPrefferedRegion:
        this.updateFieldValues(GetPreferredRegionValues(), 'preferredRegion');
        break;
      case UATConstants.UATFields.NominationType:
        this.updateFieldValues(GetNominationTypeValues(), 'nominationType');
        break;
      case UATConstants.UATFields.RB_Area:
        this.updateFieldValues(GetRBAreaOptions(), 'rbArea');
        break;
      case UATConstants.UATFields.RB_Region:
        this.updateFieldValues(GetRegionOptions(), 'rbRegion');
        break;
      case UATConstants.UATFields.RB_Country:
        this.updateFieldValues(GetCountryOptions(), 'rbCountry');
        break;
      case UATConstants.UATFields.RB_Technology:
        this.updateFieldValues(GetTechnologyOptions(), 'rbTechnology');
        break;
      case UATConstants.UATFields.RB_TicketReason:
        this.updateFieldValues(GetTicketReasonOptions(), 'rbTicketReason');
        break;
      case UATConstants.UATFields.RB_GeneralCategory:
        this.updateFieldValues(GetGeneralCategoryOptions(), 'rbGeneralCategory');
        break;
      case UATConstants.UATFields.RB_InfraLocation:
        this.updateFieldValues(GetCloudVsOnpremOptions(), 'rbInfraLocation');
        break;
      case UATConstants.UATFields.IsAmendemeentSigned:
        this.updateFieldValues(GetYesOrNo(), 'yesOrNo');
        break;
      case UATConstants.UATFields.ECIF_TypeofFunds:
        this.updateFieldValues(GetTypeOfFunds(), 'eciffundtype');
        break;
      case UATConstants.UATFields.ECIF_ProgramName:
        this.updateFieldValues(GetProgramName(), 'ecifprogramName');
        break;
      case UATConstants.UATFields.ECIF_EntityType:
        this.updateFieldValues(GetEntityTypeValues(), 'ecifEntityType');
        break;
      case UATConstants.UATFields.ECIF_DeliveryMethod:
        this.updateFieldValues(GetDeliveryMethodValues(), 'ecifDeliveryMethod');
        break;
      case UATConstants.UATFields.ECIF_IncrementalACR:
        this.updateFieldValues(GetYesOrNo(), 'yesOrNo');
        break;
      case UATConstants.UATFields.ECIF_SpendPlan:
        this.updateFieldValues(GetYesOrNo(), 'yesOrNo');
        break;
      case UATConstants.UATFields.ECIF_SupplierSameAsCustomer:
        this.updateFieldValues(GetYesOrNo(), 'yesOrNo');
        break;
      case UATConstants.UATFields.ECIF_TypeofActivity:
        this.updateFieldValues(GetActivityTypes(), 'ecifTypeofActivity');
        break;
      case UATConstants.UATFields.ECIF_ROIAttached:
        this.updateFieldValues(GetYesOrNo(), 'yesOrNo');
        break;
      case UATConstants.UATFields.MaaS_RequestType:
        this.updateFieldValues(GetMaaSRequestTypeOptions(), 'MaaS_RequestType');
        break;
      case UATConstants.UATFields.MaaS_Role:
        this.updateFieldValues(GetMaaSRoleOptions(), 'MaaS_Role');
        break;
      case UATConstants.UATFields.MaaS_Marketer_Role:
        this.updateFieldValues(GetMaaSSubRoleOptionsByRole('Marketer'), 'MaaS_Marketer_Role');
        break;
      case UATConstants.UATFields.MaaS_Seller_Role:
        this.updateFieldValues(GetMaaSSubRoleOptionsByRole('Seller'), 'MaaS_Seller_Role');
        break;
      case UATConstants.UATFields.MaaS_Area:
        this.updateFieldValues(GetMaaSAreaOptions(), 'MaaS_Area');
        break;
      case UATConstants.UATFields.MaaS_OU:
        this.updateFieldValues(GetMaaSOUOptions(), 'MaaS_OU');
        break;
      case UATConstants.UATFields.MaaS_Industry:
        this.updateFieldValues(GetMaaSIndustryOptions(), 'MaaS_Industry');
        break;
      case UATConstants.UATFields.MaaS_Segment:
        this.updateFieldValues(GetMaaSSegmentOptions(), 'MaaS_Segment');
        break;
      case UATConstants.UATFields.MaaS_SubSegment:
        this.updateFieldValues(GetMaaSSubSegementOptions(), 'MaaS_SubSegment');
        break;
      case UATConstants.UATFields.MaaS_MCEM_Stage:
        this.updateFieldValues(GetMaaSMCEMOptions(), 'MaaS_MCEM_Stage');
        break;
      case UATConstants.UATFields.MaaS_TechTargetexistingAccount:
        this.updateFieldValues(GetMaaSMaaSIsExistingAccOptions(), 'MaaS_TechTargetexistingAccount');
        break;
      case UATConstants.UATFields.MaaS_IsInterestedOrgChat:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse', 'MaaS_IsInterestedOrgChat');
        break;
      case UATConstants.UATFields.MaaS_IsInterestedAccountProfile:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse', 'MaaS_IsInterestedAccountProfile');
        break;
      case UATConstants.UATFields.MaaS_SpecificCountry:
        this.updateFieldValues(GetAreas(), 'area');
        break;
      case UATConstants.UATFields.MaaS_UpdateExistingAccount:
        this.updateFieldValues(GetMaaSExistingAccountValues(), 'MaaS_ExistingAccountValues');
        break;
      case MACCConstants.UATFields.MACCReasonforException:
        this.updateFieldValues(GetReasonForExceptionOptions(), 'maccReasonforException');
        break;
      case MACCConstants.UATFields.MACCIS_Sales_Engaged:
        this.updateFieldValues(GetTrueFalse(), 'trueFalse', 'MACCIS_Sales_Engaged');
        break;
      case UATConstants.UATFields.GPS_RequestType:
        this.updateFieldValues(GetGPSRequestTypeOptions(), 'GPS_RequestType');
        break;
      case UATConstants.UATFields.GPS_DiscussionType:
        this.updateFieldValues(GetGPSDiscussionOptions(), 'GPS_DiscussionType');
        break;
      case UATConstants.UATFields.GPS_Business:
        this.updateFieldValues(GetGPSBusinessOptions(), 'GPS_Business');
        break;
      case UATConstants.UATFields.GPS_Product:
        this.updateFieldValues(GetGPSProductOptions(), 'GPS_Product');
        break;
      case UATConstants.UATFields.GPS_PartnerType:
        this.updateFieldValues(GetGPSPartnerOptions(), 'GPS_PartnerType');
        break;
      case UATConstants.UATFields.GPS_InvestmentType:
        this.updateFieldValues(GetGPSInvestmentTypeOptions(), 'GPS_InvestmentType');
        break;
      case UATConstants.UATFields.GPS_InvestmentComplexity:
        this.updateFieldValues(GPSInvestmentComplexity(), 'GPS_InvestmentComplexity');
        break;
      case UATConstants.UATFields.GPS_PIRDecision:
        this.updateFieldValues(GetGPSPIRDecisionOptions(), 'GPS_PIRDecision');
        break;
      case UATConstants.UATFields.GPS_Stage:
        this.updateFieldValues(GetStageOptions(), 'GPS_Stage');
        break;
      case UATConstants.UATFields.GPS_FundingSource:
        this.updateFieldValues(GetGPSFundingSourceOptions(), 'GPS_FundingSource');
        break;
      case UATConstants.UATFields.GPS_FundingType:
        this.updateFieldValues(GetGPSFundingTypeOptions(), 'GPS_FundingType');
        break;
      case UATConstants.UATFields.AMM_ScopeOfWork:
        this.updateFieldValues(GetAMMScopeOfWorkOptions(), 'AMM_ScopeOfWork');
        break;
      case UATConstants.UATFields.AMM_ActionTaken:
        this.updateFieldValues(GetAMMActionTakenOptions(), 'AMM_ActionTaken');
        break;
      case UATConstants.UATFields.AMM_Offer:
        this.updateFieldValues(GetAMMOfferOptions(), 'AMM_Offer');
        break;
      case UATConstants.UATFields.AMM_OfferEngineStatus:
        this.updateFieldValues(GetAMMOfferEnginestatusOptions(), 'AMM_OfferEnginestatus');
        break;
      case UATConstants.UATFields.AMM_AVSOfferEngineStatus:
          this.updateFieldValues(GetAMMOfferEnginestatusOptions(), 'AMM_AVSOfferEngineStatus');
        break;  
      case UATConstants.UATFields.AMM_CMFOfferEngineStatus:
          this.updateFieldValues(GetAMMOfferEnginestatusOptions(), 'AMM_CMFOfferEngineStatus');
        break; 
      case UATConstants.UATFields.AMM_ECIFOfferEngineStatus:
          this.updateFieldValues(GetAMMOfferEnginestatusOptions(), 'AMM_ECIFOfferEngineStatus');
        break;   
      case UATConstants.UATFields.AMM_OfferEngineType:
        this.updateFieldValues(GetAMMOfferEngineTypeOptions(), 'AMM_OfferEngineType');
        break;
      case UATConstants.UATFields.AMM_AVSOfferEngineType:   
          this.updateFieldValues(GetAMMOfferEngineTypeOptions(), 'AMM_AVSOfferEngineType');
        break;
      case UATConstants.UATFields.AMM_CMFOfferEngineType:
          this.updateFieldValues(GetAMMOfferEngineTypeOptions(), 'AMM_CMFOfferEngineType');
        break;
       case UATConstants.UATFields.AMM_ECIFOfferEngineType:
          this.updateFieldValues(GetAMMOfferEngineTypeOptions(), 'AMM_ECIFOfferEngineType');
        break;   
      case UATConstants.UATFields.AMM_CancellationReason:
        this.updateFieldValues(GetAMMCancellationReasonOptions(), 'AMM_Cancellationreason');
        break;
      case UATConstants.UATFields.AMM_RejectionReason:
        this.updateFieldValues(GetAMMRejectionReasonOptions(), 'AMM_Rejectionreason');
        break;
      case UATConstants.UATFields.AMM_DisqualificationReason:
        this.updateFieldValues(GetAMMDisqualificationReasonOptions(), 'AMM_DisqualificationReason');
        break;
      case UATConstants.UATFields.AMM_AAOfferType:
        this.updateFieldValues(GetAMMAaofertypeOptions(), 'AMM_AaoferType');
        break;
      case UATConstants.UATFields.AMM_PendingActionFrom:
        this.updateFieldValues(GetAMMPendingactionfromnOptions(), 'AMM_PendingActionFrom');
        break;
      case UATConstants.UATFields.AMM_NextBestAction:
        this.updateFieldValues(GetAMMNextBestActionOptions(), 'AMM_NextBestAction');
        break;
      case UATConstants.UATFields.AMM_TypeOfFundingNeeded:
        this.updateFieldValues(GetAMMTypeOfFundingNeededOptions(), 'AMM_TypeOfFundingNeeded');
        break;
      case UATConstants.UATFields.AMM_MicrosoftDefenderforCloud:
        this.updateFieldValues(GetAMMMicrosoftdefenderforcloudOptions(), 'AMM_Microsoftdefenderforcloud');
        break;
      case UATConstants.UATFields.AMM_CommunicationPreference:
        this.updateFieldValues(GetAMMCommunicationPreferenceOptions(), 'AMM_CommunicationPreference');
        break;
      case UATConstants.UATFields.AMM_DoyouwanttorequestACOinadditiontoECIF:
        this.updateFieldValues(GetAMMDoYouWantToRequestAcoInAdditionToEcifOptions(), 'AMM_DoYouWantToRequestAcoInAdditionToEcif');
        break;
      case UATConstants.UATFields.AMM_DealStructure:
        this.updateFieldValues(GetAMMDealStructureOptions(), 'AMM_DealStructure');
        break;
      case UATConstants.UATFields.AMM_SupportRegion:
        this.updateFieldValues(GetAMMSupportRegionOptions(), 'AMM_SupportRegion');
        break;
      case UATConstants.UATFields.AMM_Program:
        this.updateFieldValues(GetAMMProgramOptions(), 'AMM_Program');
        break;
      case UATConstants.UATFields.AMM_SupportedScenario:
        this.updateFieldValues(GetAMMSupportedScenarioOptions(), 'AMM_SupportedScenario');
        break;
      case UATConstants.UATFields.AMM_MigrationPartnerAttached:
        this.updateFieldValues(GetAMMMigrationPartnerAttachedOptions(), 'AMM_MigrationPartnerAttached');
        break;
      case UATConstants.UATFields.AMM_WillThisRequestRequireAdditionalAttendees:
        this.updateFieldValues(GetAMMWillThisRequestRequireAdditionalAttendeesOptions(), 'AMM_WillThisRequestRequireAdditionalAttendees');
        break;
      case UATConstants.UATFields.AMM_RequestType:
        this.updateFieldValues(GetAMMRequestTypeOptions(), 'AMM_RequestType');
        break;
      case UATConstants.UATFields.AMM_ESI:
        this.updateFieldValues(GetAMMEsiOptions(), 'AMM_Esi');
        break;
      case UATConstants.UATFields.AMM_FTA:
        this.updateFieldValues(GetAMMFtaOptions(), 'AMM_Fta');
        break;
      case UATConstants.UATFields.AMM_PreOrPost:
        this.updateFieldValues(GetAMMPreOrPostOptions(), 'AMM_PreOrPost');
        break;
      case UATConstants.UATFields.AMM_CustomerCommitment:
        this.updateFieldValues(GetAMMCustomerCommitmentToStartOptions(), 'AMM_CustomerCommitment');
        break;
      case UATConstants.UATFields.AMM_RequestReason:
        this.updateFieldValues(GetAMMRequestReasonOptions(), 'AMM_RequestReason');
        break;
      case UATConstants.UATFields.AMM_FutureGrowthOffer:
        this.updateFieldValues(GetAMMAzureFutureGrowthOfferOptions(), 'AMM_AzureFutureGrowthOffer');
        break;
      case UATConstants.UATFields.AMM_ECIFFutureGrowthOffer:
        this.updateFieldValues(GetAMMECIFFutureGrowthOfferOptions(), 'AMM_ECIFFutureGrowthOffer');
        break;
      case UATConstants.UATFields.AMM_PrimarySolutionPlay:
        this.updateFieldValues(GetAMMPrimarySolutionOptions(), 'AMM_PrimarySolutionPlaySupporting');
        break;
      case UATConstants.UATFields.AMM_SupplierType:
        this.updateFieldValues(GetAMMAaofertypeOptions(), 'AMM_SupplierType');
        break;
      case UATConstants.UATFields.AMM_HelpType:
        this.updateFieldValues(GetAMMHelpTypeOptions(), 'AMM_HelpType');
        break;
      case UATConstants.UATFields.AMM_FutureGrowthECIF:
        this.updateFieldValues(GetAMMECIFFutureGrowthOfferOptions(), 'AMM_ECIFFutureGrowthOffer');
        break;
      case UATConstants.UATFields.AMM_FinancialYear:
        this.updateFieldValues(GetAMMFinacialYearOptions(), 'AMM_FinancialYear');
        break;
      case UATConstants.UATFields.AMM_HelpCategory:
        this.updateFieldValues(GetAMMHelpTypeOptions(), 'AMM_HelpType');
        break;
      case UATConstants.UATFields.AMM_PRIMARYAzurevirtualmachineVMseries:
        this.updateFieldValues(GetPrimaryAzureVirtualMachineOptions(), 'Amm_primaryazurevirtualmachinevmseries');
        break;
      case UATConstants.UATFields.AMM_SAPOffer:
        this.updateFieldValues(GetAMMSAPOfferOptions(), 'AMM_SapOffer');
        break;
      case UATConstants.UATFields.AMM_ServiceLocation:
        this.updateFieldValues(GetAMMServiceLocationOptions(), 'AMM_ServiceLocation');
        break;
      case UATConstants.UATFields.AMM_IsThisRequestRelated:
        this.updateFieldValues(GetAMMYesOrNoOptions(), 'AMM_YesOrNo');
        break;
      case UATConstants.UATFields.AMM_IsThisAVMCToAVSMigration:
        this.updateFieldValues(GetAMMYesOrNoOptions(), 'AMM_YesOrNo');
        break;
      case UATConstants.UATFields.AMM_IsThereExistingACO:
        this.updateFieldValues(GetAMMYesOrNoOptions(), 'AMM_YesOrNo');
        break;
      case UATConstants.UATFields.AMM_DoesThisIncludeHighRiskDeal:
        this.updateFieldValues(GetAMMYesOrNoOptions(), 'AMM_YesOrNo');
        break;
      case UATConstants.UATFields.AMM_IsThereACompetitiveBid:
        this.updateFieldValues(GetAMMYesOrNoOptions(), 'AMM_YesOrNo');
        break;
      case UATConstants.UATFields.AMM_OfferDeskRegion:
        this.updateFieldValues(GetAMMOfferDeskRegionOptions(), 'AMM_OfferDeskRegion');
        break;
      case UATConstants.UATFields.ECIF_RequestReason:
        this.updateFieldValues(GetECIFRequestReason(), "ecifRequestReason")
        break;
      case UATConstants.UATFields.ECIF_DealStructure:
        this.updateFieldValues(GetECIFDealStructure(), "ecifDealStructure")
        break;
      case UATConstants.UATFields.ECIF_Approved_Rejected:
        this.updateFieldValues(GetECIFApprovedOrRejected(), "ECIF_Approved_Rejected")
        break;
    }
  }

  private updateFieldValues(fieldValues: any, fieldProp: string, fieldName: string = '') {
    const options: IDropdownOption[] = [];
    if (fieldProp == UATConstants.UATKeyTerms.tagName) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.TagId,
          text:
            item.TagName.length > UATConstants.UATKeyTerms.tagMaxLength
              ? item.TagName.substr(0, UATConstants.UATKeyTerms.tagMaxLength) +
              UATConstants.UATKeyTerms.ellipses
              : item.TagName,
          title: item.TagName,
        });
      });
      const selectedFieldValueIds: any[] = [];
      const selectedFieldValues: any[] = [];
      if (this.state.queryGroup.value.values.length > 0) {
        this.state.queryGroup.value.values.forEach((element) => {
          const FindOption = options.filter((x) => x.key === element);
          selectedFieldValueIds.push(FindOption[0].key);
          selectedFieldValues.push(FindOption[0].text);
        });
      }
      this.setState({
        tagOptions: options,
        selectedFieldValueIds: selectedFieldValueIds,
        selectedFieldValues: selectedFieldValues,
      });
    } else if (
      fieldProp === 'System.Area/AreaPath' ||
      fieldProp === UATConstants.UATKeyTerms.AreaPathCustom
    ) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.id,
          text: item.areaPathCustom,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.rbArea) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.rb_AreaID,
          text: item.rb_Area,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.rbRegion) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.rb_RegionID,
          text: item.rb_Region,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.rbCountry) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.rb_CountryID,
          text: item.rb_Country,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.rbTechnology) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.rb_TechnologyID,
          text: item.rb_Technology,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.rbTicketReason) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.rb_TicketReasonID,
          text: item.rb_TicketReason,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.rbGeneralCategory) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.rb_GeneralCategoryID,
          text: item.rb_GeneralCategory,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.rbInfraLocation) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.rb_infraLocationID,
          text: item.rb_infraLocation,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.eciffundtype) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.id,
          text: item.fundtype,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.ecifprogramName) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.id,
          text: item.programName,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.ecifEntityType) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.id,
          text: item.entityType,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.ecifDeliveryMethod) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.id,
          text: item.deliveryMethod,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.yesOrNo) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.id,
          text: item.yesOrNo,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.ecifTypeofActivity) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.id,
          text: item.activityType,
        });
      });
    }
    else if (fieldProp === UATConstants.UATKeyTerms.MaaSRequestType) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.ID,
          text: item.MaaSRequestType,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.MaaSRole) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.ID,
          text: item.Role,
        });
      });
    } else if (
      fieldProp === UATConstants.UATKeyTerms.MaaSMarketerRole ||
      fieldProp === UATConstants.UATKeyTerms.MaaSSellerRole
    ) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.ID,
          text: item.SubRole,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.MaaSArea) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.ID,
          text: item.Area,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.MaaSIndustry) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.ID,
          text: item.Industry,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.MaaSIndustry) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.ID,
          text: item.Industry,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.MaaSOU) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.MaaS_ID,
          text: item.MaaS_OU,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.MaaSSegment) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.ID,
          text: item.Segment,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.MaaSSubSegment) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.ID,
          text: item.SubSegment,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.MaaSMCEMStage) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.ID,
          text: item.MCEM,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.MaaSTechTargetexistingAccount) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.id,
          text: item.option,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.MaaSExistingAccountValues) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.ID,
          text: item.ExistingAccountValues,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.MaccReasonforException) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.id,
          text: item.reason,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.GPSRequestType) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.gpsRequestType,
          text: item.gpsRequestType,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.GPSDiscussionType) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.gpsDiscussionType,
          text: item.gpsDiscussionType,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.GPSBusiness) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.gpsBusiness,
          text: item.gpsBusiness,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.GPSProduct) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.gpsProduct,
          text: item.gpsProduct,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.GPSPartnerType) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.gpsPartnerType,
          text: item.gpsPartnerType,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.GPSInvestmentType) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.gpsInvestmentType,
          text: item.gpsInvestmentType,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.GPSInvestmentComplexity) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.gpsInvestmentComplexity,
          text: item.gpsInvestmentComplexity,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.GPSPIRDecision) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.gpsPIRDecision,
          text: item.gpsPIRDecision,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.GPSStage) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.gpsStage,
          text: item.gpsStage,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.GPSFundingSource) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.gpsFundingSource,
          text: item.gpsFundingSource,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.GPSFundingType) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.gpsFundingType,
          text: item.gpsFundingType,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.ecifRequestReason) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.requestReason,
          text: item.requestReason,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.ecifDealStructure) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.dealStructure,
          text: item.dealStructure,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.ECIF_Approved_Rejected) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.value,
          text: item.value,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AOAIModel) {
      let uniqueIdsString: string = '';
      fieldValues.forEach((item: any) => {
        if (!uniqueIdsString.includes(String(item.model))) {
          if (uniqueIdsString !== '') {
            uniqueIdsString += ',';
          }
          uniqueIdsString += String(item.model);
          options.push({
            key: item.id,
            text: item.model,
          });
        }
      });
      options.sort((a, b) => a.text.localeCompare(b.text));
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmPendingactionfrom) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_pendingactionfrom,
          text: item.amm_pendingactionfrom,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AMMFutureGrowthECIF) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_eciffuturegrowthOffer,
          text: item.amm_eciffuturegrowthOffer,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmAaofertype) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_aaofertype,
          text: item.amm_aaofertype,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AMMDoYouWantToRequestAcoInAdditionToEcif) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_doYouWantToRequestAcoInAdditionToEcif,
          text: item.amm_doYouWantToRequestAcoInAdditionToEcif,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmEsi) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_esi,
          text: item.amm_esi,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmFta) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_fta,
          text: item.amm_fta,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AMMFinancialYear) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_financialyear,
          text: item.amm_financialyear,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AMMScopeOfWork) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_scopeOfWork,
          text: item.amm_scopeOfWork,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmRejectionreason) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_rejectionreason,
          text: item.amm_rejectionreason,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmTypeoffundingneeded) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_typeoffundingneeded,
          text: item.amm_typeoffundingneeded,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmSupportRegion) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_supportregion,
          text: item.amm_supportregion,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmProgram) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_program,
          text: item.amm_program,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmSupportedScenario) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_supportedScenario,
          text: item.amm_supportedScenario,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmWillThisRequestRequireAdditionalAttendees) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_willthisrequestrequireadditionalattendees,
          text: item.amm_willthisrequestrequireadditionalattendees,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmRequestType) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_requestType,
          text: item.amm_requestType,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmPreOrPost) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_preorpost,
          text: item.amm_preorpost,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmCustomerCommitment) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_customercommitment,
          text: item.amm_customercommitment,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AMMRequestReason) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_requestreason,
          text: item.amm_requestreason,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AMMAzureFutureGrowthOffer) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_azurefuturegrowthOffer,
          text: item.amm_azurefuturegrowthOffer,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AMMPrimarySolutionPlaySupporting) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_primarysolutionplaysupporting,
          text: item.amm_primarysolutionplaysupporting,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AMMSapOffer) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_sapoffer,
          text: item.amm_sapoffer,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AMMServiceLocation) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_servicelocation,
          text: item.amm_servicelocation,
        });
      });
    } else if (
      fieldProp === UATConstants.UATKeyTerms.AMMIsThisRequestRelated ||
      fieldProp === UATConstants.UATKeyTerms.AMMIsThisAVMCToAVSMigration ||
      fieldProp === UATConstants.UATKeyTerms.AMMIsThereExistingACO ||
      fieldProp === UATConstants.UATKeyTerms.AMMDoesThisIncludeHighRiskDeal ||
      fieldProp === UATConstants.UATKeyTerms.AMMIsThereACompetitiveBid
    ) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.value,
          text: item.value,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmActionTaken) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_actionTaken,
          text: item.amm_actionTaken,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmOfferEnginestatus) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_offerEnginestatus,
          text: item.amm_offerEnginestatus,
        });
      });
    }  else if(fieldProp ===
      UATConstants.UATKeyTerms.AMMOfferEngineType){
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_OfferEngineTypeName,
          text: item.amm_OfferEngineTypeName,
        });
      });
    } else if (fieldProp ===
      UATConstants.UATKeyTerms.AMMAVSOfferEngineType) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_OfferEngineTypeName,
          text: item.amm_OfferEngineTypeName,
        });
      });
    } else if (fieldProp ===
      UATConstants.UATKeyTerms.AMMCMFOfferEngineType) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_OfferEngineTypeName,
          text: item.amm_OfferEngineTypeName,
        });
      });
    } else if (fieldProp ===
      UATConstants.UATKeyTerms.AMMECIFOfferEngineType) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_OfferEngineTypeName,
          text: item.amm_OfferEngineTypeName,
        });
      });    
    } else if (fieldProp ===
      UATConstants.UATKeyTerms.AMMAVSOfferEngineStatus) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_offerEnginestatus,
          text: item.amm_offerEnginestatus,
        });
      });
    } else if (fieldProp ===
      UATConstants.UATKeyTerms.AMMCMFOfferEngineStatus) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_offerEnginestatus,
          text: item.amm_offerEnginestatus,
        });
      });
    } else if (fieldProp ===
      UATConstants.UATKeyTerms.AMMECIFOfferEngineStatus) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_offerEnginestatus,
          text: item.amm_offerEnginestatus,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmOffer) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_offer,
          text: item.amm_offer,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmCancellationreason) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_cancellationreason,
          text: item.amm_cancellationreason,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmDisqualificationreason) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_disqualificationreason,
          text: item.amm_disqualificationreason,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmNextbestaction) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_nextbestaction,
          text: item.amm_nextbestaction,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmMicrosoftdefenderforcloud) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_microsoftdefenderforcloud,
          text: item.amm_microsoftdefenderforcloud,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.Ammprimaryazurevirtualmachinevmseries) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_primaryazurevirtualmachinevmseries,
          text: item.amm_primaryazurevirtualmachinevmseries,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmCommunicationpreference) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_communicationpreference,
          text: item.amm_communicationpreference,
        });
      });
    }
    else if (fieldProp === UATConstants.UATKeyTerms.AmmDealstructure) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_dealStructure,
          text: item.amm_dealStructure,
        });
      });
    }
    else if (fieldProp === UATConstants.UATKeyTerms.AMMECIFFutureGrowthOffer) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_eciffuturegrowthOffer,
          text: item.amm_eciffuturegrowthOffer,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AmmMigrationpartnerattached) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_migrationpartnerattached,
          text: item.amm_migrationpartnerattached,
        });
      });

    } else if (fieldProp === UATConstants.UATKeyTerms.AMMSupplierType) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_suppliertype,
          text: item.amm_suppliertype,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AMMHelpType) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_helptype,
          text: item.amm_helptype,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.AMMOfferDeskRegion) {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.amm_offerDeskRegion,
          text: item.amm_offerDeskRegion,
        });
      });
    } else if (fieldProp === UATConstants.UATKeyTerms.Operating_Unit) {
      fieldValues.forEach((item: any) => {
        if (!options.some(({ key, text }) => text == item.operatingUnit)) {
          options.push({
            key: item.id,
            text: item[fieldProp],
          });
        }
      });
      options.sort((a, b) => a.text.localeCompare(b.text));
    } else {
      fieldValues.forEach((item: any) => {
        options.push({
          key: item.id,
          text: item[fieldProp],
        });
      });
    }

    this.setState({
      fieldValueOptions: options,
    });
    if (fieldProp === UATConstants.UATKeyTerms.AssignToCorp) {
      this.setState({ assignToCorpField: true });
      this.setSelectedValues(options);
    } else if (
      fieldProp === 'System.Area/AreaPath' ||
      fieldProp === UATConstants.UATKeyTerms.AreaPathCustom
    ) {
      this.setSelectedAssignedTeamValues(options);
    } else {
      this.setSelectedValues(options);
    }
  }

  private setSelectedValues(options: IDropdownOption[]) {
    const selectedFieldValueIdList = [];
    const selectedFieldValuesList = [];
    for (var i in this.props.queryItem.value.values) {
      let selectedOption: any = [];
      if (this.state.isTags && this.props.queryItem.fieldName === UATConstants.UATFields.Tags) {
        selectedOption = options.find((e) => e.key === this.state.queryGroup.value.values[i]);
        if (selectedOption === undefined && this.state.queryGroup.value.values[i].length > 0) {
          let value: any = '';
          value = this.state.queryGroup.value.values[i];
          value = value ? sanitizeText(value) : (value as string);
          options[options.length] = {
            key: value,
            text: value,
            title: value,
          };
          selectedFieldValueIdList.push(value);
          selectedFieldValuesList.push(value);
        }
      } else if (this.props.queryItem.fieldName === UATConstants.UATFields.AssigntoCorp) {
        var assignToCorpSelected = this.state.queryGroup.value.values[i];
        if (assignToCorpSelected && !assignToCorpSelected.startsWith(UATConstants.atParam)) {
          assignToCorpSelected = assignToCorpSelected === 'True' ? 'Yes' : 'No';
        }

        selectedOption = options.find((e) => e.text === assignToCorpSelected);
      } else {
        selectedOption = options.find((e) => e.text === this.state.queryGroup.value.values[i]);
      }
      if (selectedOption !== undefined) {
        selectedFieldValueIdList.push(selectedOption.key);
        selectedFieldValuesList.push(selectedOption.text);
      }
    }
    if (selectedFieldValueIdList && selectedFieldValueIdList.length > 0) {
      this.setState({
        fieldValueOptions: options,
        selectedFieldValueIds: selectedFieldValueIdList,
        selectedFieldValues: selectedFieldValuesList,
      });
    } else {
      this.setState({ fieldValueOptions: options });
    }
  }
  private setSelectedAssignedTeamValues(options: IDropdownOption[]) {
    const fieldValueOptions = options;
    const selectedFieldValueIdList = [];
    const selectedFieldValuesList = [];
    for (var i in this.props.queryItem.value.values) {
      const selectedOption: any = this.props.assignedTeam.find(
        (e) => e.areaId === this.state.queryGroup.value.values[i]
      );
      if (selectedOption !== undefined) {
        selectedFieldValueIdList.push(selectedOption.id);
        let areaPathObj = selectedOption.areaPath.replace(/\\/g, ' ').replace(/@/g, '');
        areaPathObj = areaPathObj.replace(UATConstants.Project, '');
        selectedFieldValuesList.push(areaPathObj);
      } else {
        var areaPath = this.props.queryItem.value.values[i].replace(/\\/g, ' ').replace(/@/g, '');
        if (areaPath != '') {
          areaPath = areaPath.replace(UATConstants.Project, '');
          const areaPathObj: any = this.props.assignedTeam.find(
            (e) => e.areaPathCustom === areaPath
          );
          const Dropdown = { text: areaPath, key: areaPathObj.id };
          fieldValueOptions.splice(1, 0, Dropdown);
          selectedFieldValueIdList.push(areaPathObj.areaId);
          selectedFieldValuesList.push(Dropdown.text);
        }
      }
    }
    if (selectedFieldValueIdList.length > 0) {
      this.setState({
        selectedFieldValueIds: selectedFieldValueIdList,
        selectedFieldValues: selectedFieldValuesList,
      });
    } else {
      this.setState({ fieldValueOptions: fieldValueOptions });
    }
  }

  private onSQLOperatorChange = (event: any, option: IDropdownOption) => {
    const queryGroup = { ...this.state.queryGroup };
    queryGroup.fieldOperation = parseInt(option.key.toString(), 10);
    if (this.state.queryGroup.fieldName === 'TagNames') {
      this.setState({ isTags: true });
    }

    this.setState(
      {
        queryGroup,
        selectedSQLOperatorId: parseInt(option.key.toString(), 10),
        selectedSQLOperator: option.text,
      },
      () => this.props.updateParentList(this.state.queryGroup)
    );
  };

  private onLogicalRadioButtonChangeCallBack = (option: any) => {
    const queryGroup = { ...this.state.queryGroup };
    queryGroup.value.mode = 0;
    queryGroup.value.operator = (option as string) === 'Or' ? 1 : 0;
    this.setState(
      {
        queryGroup,
      },
      () => {
        this.props.updateParentList(this.state.queryGroup);
        this.validate();
      }
    );
  };

  private onFieldValueChange = (option: any) => {
    const queryGroup = { ...this.state.queryGroup };
    let selectedFieldValueIdList = [...this.state.selectedFieldValueIds];
    let selectedFieldValuesList = [...this.state.selectedFieldValues];
    if (!this.state.isMultiSelect) {
      selectedFieldValueIdList.splice(0, selectedFieldValueIdList.length);
      selectedFieldValuesList.splice(0, selectedFieldValuesList.length);
    }
    if (this.state.isMultiSelect === true) {
      selectedFieldValuesList = option;
      selectedFieldValueIdList = [];
      this.state.fieldValueOptions.forEach((item) => {
        if (selectedFieldValuesList.includes(item.text)) {
          selectedFieldValueIdList.push(item.key);
        }
      });
    } else {
      if (selectedFieldValueIdList.some((arrVal) => option.key === arrVal)) {
        const currIndex = selectedFieldValueIdList.indexOf(option.key as number);
        if (currIndex > -1) {
          selectedFieldValueIdList.splice(currIndex, 1);
          selectedFieldValuesList.splice(currIndex, 1);
          // isValid = true;
        }
      } else {
        selectedFieldValueIdList.push(option.key as number);
        selectedFieldValuesList.push(option.text);
      }
    }

    if (queryGroup.fieldName === 'Area/AreaPath') {
      if (this.state.isMultiSelect == true) {
        const areaPathObj: string[] = [];
        option.forEach((element: any) => {
          if (element) {
            const selectedOption: any = this.props.assignedTeam.find(
              (e) => e.areaPathCustom === element
            );
            areaPathObj.push(selectedOption.areaId);
          }
          queryGroup.value.values = areaPathObj;
        });
      } else {
        const selectedOption: any = this.props.assignedTeam.find(
          (e) => e.id === (option.key as number)
        );
        queryGroup.value.values = [selectedOption.areaId];
      }
    } else {
      queryGroup.value.values = this.state.isMultiSelect
        ? compact(selectedFieldValuesList)
        : [selectedFieldValuesList[selectedFieldValueIdList.length - 1]];
    }
    if (queryGroup.fieldName === 'TagNames') {
      queryGroup.value.values = selectedFieldValueIdList;
    }
    if (
      queryGroup.fieldName === UATConstants.UATFields.AssigntoCorp &&
      this.state.assignToCorpField
    ) {
      if (!option.text.startsWith(UATConstants.atParam)) {
        queryGroup.value.values = option.text === 'Yes' ? ['True'] : ['False'];
      }
    }

    this.setState(
      {
        queryGroup,
        selectedFieldValueIds: this.state.isMultiSelect
          ? selectedFieldValueIdList
          : [selectedFieldValueIdList[selectedFieldValueIdList.length - 1]],
        selectedFieldValues: this.state.isMultiSelect
          ? selectedFieldValuesList
          : [selectedFieldValuesList[selectedFieldValuesList.length - 1]],
        isValueValid: true,
      },
      () => {
        this.props.updateParentList(this.state.queryGroup);
        this.validate();
      }
    );
  };

  private onDateFieldValueChange = (selectedDate: Date) => {
    const selectedFieldValuesList = [];
    const queryGroup = { ...this.state.queryGroup };

    selectedFieldValuesList.push(selectedDate.toISOString().split('T')[0]);
    queryGroup.value.values = selectedFieldValuesList;
    this.setState(
      {
        queryGroup,
        isValueValid: true,
      },
      () => {
        this.props.updateParentList(this.state.queryGroup);
        this.validate();
      }
    );
  };

  private onBooleanFieldValueChange = (checked: boolean) => {
    const selectedFieldValuesList = [];
    const queryGroup = { ...this.state.queryGroup };

    selectedFieldValuesList.push(checked ? 'true' : 'false');
    queryGroup.value.values = selectedFieldValuesList;
    this.setState(
      {
        queryGroup,
        isValueValid: true,
      },
      () => {
        this.props.updateParentList(this.state.queryGroup);
        this.validate();
      }
    );
  };

  private deleteItem() {
    this.props.onDelete(this.state.queryGroup.id);
  }

  /**
   * A callback for when the selected list of items changes.
   */
  private _onChangePeopleGetAssignTo = (items: any) => {
    const queryGroup = { ...this.state.queryGroup };
    if (items.length !== 0) {
      const selectedFieldValueIdList: string[] = [];
      const selectedFieldValuesList: string[] = [];

      items.forEach((element: any) => {
        if (
          !(
            selectedFieldValueIdList.includes(element.key) ||
            selectedFieldValueIdList.includes(element.text)
          )
        ) {
          selectedFieldValueIdList.push(element.key ? element.key : element.text);
          selectedFieldValuesList.push(element.text);
        }
      });

      queryGroup.value.values = this.state.isMultiSelect
        ? uniq(selectedFieldValueIdList)
        : [selectedFieldValueIdList[selectedFieldValueIdList.length - 1]];
      this.setState(
        {
          queryGroup,
          selectedFieldValueIds: selectedFieldValueIdList,
          selectedFieldValues: selectedFieldValuesList,
          isValueValid: true,
        },
        () => {
          this.props.updateParentList(this.state.queryGroup);
          this.validate();
        }
      );
    } else {
      queryGroup.value.values = [];
      this.setState(
        {
          queryGroup,
          selectedFieldValueIds: [],
          selectedFieldValues: [],
        },
        () => this.props.updateParentList(this.state.queryGroup)
      );
    }
  };

  private onTextFieldValueChange = (event: any, newText: string) => {
    newText = newText ? this.purifyText(newText) : (newText as string);

    if (this.state.isNumber) {
      if (parseInt(newText).toString() === newText) {
        this.setState({ isValueValid: true });
      } else {
        this.setState({ isValueValid: false });
      }
    }

    if (this.state.isDecimal) {
      const regex = /^\d+(\.\d{1,2})?$/;
      if (regex.test(newText)) {
        this.setState({ isValueValid: true });
      } else {
        this.setState({ isValueValid: false });
      }
    }

    const queryGroup = { ...this.state.queryGroup };

    if (UATConstants.MultiselectOperators.includes(this.state.selectedSQLOperator)) {
      ///   queryGroup.value.values = newText.split(',');
    } else {
      queryGroup.value.values[0] = newText;
    }
    this.setState({ queryGroup, selectedFieldValues: [newText] }, () => {
      this.props.updateParentList(this.state.queryGroup);
      this.validate();
    });
  };
  /**
   * @function
   * Returns people results(fullname and email) after a REST API call
   * Search for users base on Full name or email starting with characters and the number of those characters should be greater than three
   */

  private _onPeopleFilterChanged = (
    filterText: string,
    currentSelected: any,
    limitResults?: number
  ) => {
    filterText = filterText ? this.purifyText(filterText) : (filterText as string);
    const clause = { ...this.state.queryGroup };
    if (filterText.startsWith('@') && filterText.length <= 3) {
      const paramValue =
        UATConstants.atParam + '(' + clause.fieldDisplayName.toLowerCase().replace(/\s/g, '') + ')';
      return [
        { key: '@me', primaryText: '@Me', text: '@Me' },
        { key: paramValue, primaryText: paramValue, text: paramValue },
      ];
    } else if (filterText.length <= 3) {
      return [];
    } else {
      const userDetails = {
        DisplayName: filterText,
      };
      return ServiceFactoryClientExecuteApi.ExecuteRequestAsync(
        UATConstants.ApiPaths.UsersTable,
        [],
        HttpVerbs.post,
        userDetails
      );
    }
  };

  private getDefaultPersona = (personaName: string) => {
    const personaProps: IPersonaProps[] = [];
    if (personaName !== '') {
      const personaNames = personaName.split(',');
      personaNames.forEach((element) => {
        personaProps.push({
          text: element,
          onClick: (event: any) => GetUserPersona(event, this, true),
        });
      });
    }
    return personaProps;
  };

  private setButtonId = () => {
    this.setState({
      buttonId: '',
      isCalloutVisible: false,
      userContactDetails: new UserContact(),
      userManager: new UserManager(),
      onDismissFocus: false,
    });
    document.getElementById('callout-button')?.removeAttribute('id');
  };

  suggestionProps = {
    suggestionsHeaderText: 'Suggested People',
    noResultsFoundText: 'No results found',
    loadingText: 'Loading',
  };

  suggestionGroupProps = {
    suggestionsHeaderText: 'Suggested Groups',
    noResultsFoundText: 'No results found',
    loadingText: 'Loading',
  };
  private getADOTags = () => {
    if (this.props.tagsOptions.length > 0) {
      this.updateFieldValues(this.props.tagsOptions, UATConstants.UATKeyTerms.tagName);
    } else {
      ServiceFactoryClientExecuteApi.ExecuteAdoRequest<any>(
        UATConstants.ApiPaths.GetAnalyticsViewTags,
        [],
        HttpVerbs.get,
        [],
        (fields: any[]) => {
          this.updateFieldValues(fields, UATConstants.UATKeyTerms.tagName);
        },
        (response: ErrorResponse) => {
          console.error(response);
        },
        false
      );
    }
  };

  private purifyText = (text: string) => {
    const data = sanitizeText(text, true);
    if (data && data[0]) {
      const purifyMessage: IBannerMessagePayload = UATConstants.DataSanitizeMessages;
      this.props.setBanner(purifyMessage);
      return data[1].toString();
    }
    return text;
  };

  render() {
    const dropdownOperatorStyles: Partial<IDropdownStyles> = {
      dropdown: { width: 100 },
      dropdownItems: {
        maxWidth: 120,
      },
    };

    const rootClassDate = mergeStyles({ minWidth: 140 });

    const columnDisabled =
      this.state.queryGroup.fieldName === '' || this.state.logicalOperatorDisabled;
    const clause = this.state.queryGroup;
    const isFirst = this.props.queryItemIndex === 0;
    let placeHolder = '';
    if (this.state.isDecimal) {
      placeHolder = 'Enter only decimals';
    } else if (this.state.isNumber) {
      placeHolder = 'Enter only digits';
    } else if (this.state.isDate) {
      placeHolder = 'Select date';
    } else {
      placeHolder = 'Enter any value';
    }

    return (
      <>
        <tr className='clause clause-row'>
          <td className='field'>
            <div
              id='vss_370'
              className='combo input-text-box list drop ms-Grid-col ms-lg12 columnOptionsWrapper'>
              <CustomDropdown
                selectedItem={clause.fieldName}
                dropdownOptions={this.props.fieldOptions}
                placeholder=''
                onChangeCallBack={this.onFieldChange}
                label={UATConstants.PlaceholdersAndTitles.Select}
                title={clause.fieldDisplayName}
                searchable
              />
            </div>
          </td>
          <td className='operator'>
            <div id='vss_373' className='combo input-text-box list drop'>
              <SimpleDropdown
                className='dropDownHeight'
                options={this.state.sqlOptions}
                selectedKey={this.state.selectedSQLOperatorId}
                onChange={this.onSQLOperatorChange}
                styles={dropdownOperatorStyles}
                tooltipText={this.state.selectedSQLOperator}
              />
            </div>
          </td>
          <td className='value'>
            <div id='vss_376' className='field-filter-value-control'>
              <div
                id='vss_380'
                className='combo input-text-box list drop ms-Grid-col ms-lg12 columnOptionsWrapper'>
                {(this.state.isNumber ||
                  this.state.isDecimal ||
                  (!this.state.isPicklist &&
                    !this.state.isIdentity &&
                    !this.state.isDate &&
                    !this.state.isBoolean &&
                    !this.state.isAreaPathOrIteration &&
                    !this.state.isTags)) && (
                    <TextField
                      value={this.state.selectedFieldValues[0]}
                      onChange={this.onTextFieldValueChange}
                      disabled={columnDisabled}
                      title={this.state.selectedFieldValues[0]}
                      placeholder={placeHolder}
                    />
                  )}
                {this.state.isNumber && !this.state.isValueValid && (
                  <ErrorMessage
                    containerClassName='ms-Grid-col ms-Grid-row'
                    onDismiss={() => {
                      this.setState({
                        isValueValid: true,
                      });
                    }}>
                    {UATConstants.ErrorMessages.PleaseIntegervalue}
                  </ErrorMessage>
                )}

                {this.state.isDecimal && !this.state.isValueValid && (
                  <ErrorMessage
                    containerClassName='ms-Grid-col ms-Grid-row'
                    onDismiss={() => {
                      this.setState({
                        isValueValid: true,
                      });
                    }}>
                    {'Please provide a valid amount.'}
                  </ErrorMessage>
                )}

                {this.state.isBoolean && (
                  <Toggle
                    offText={UATConstants.PlaceholdersAndTitles.NO}
                    onText={UATConstants.PlaceholdersAndTitles.YES}
                    checked={this.state.toggleValue}
                    onChange={(ev: any, checked: boolean) => {
                      this.setState({
                        toggleValue: checked,
                      });
                      this.onBooleanFieldValueChange(checked);
                    }}
                  />
                )}
                {this.state.isDate && (
                  <div id='vss_3221' className={rootClassDate}>
                    <DatePicker
                      aria-label={UATConstants.PlaceholdersAndTitles.Date}
                      firstDayOfWeek={UATConstants.DatepickerDefaults.firstDayOfWeek}
                      strings={UATConstants.DayPickerStrings}
                      allowTextInput={true}
                      formatDate={formatDate}
                      title={UATConstants.PlaceholdersAndTitles.Date}
                      showMonthPickerAsOverlay={true}
                      value={this.state.selectedDate || undefined}
                      onSelectDate={(date: Date) => {
                        this.setState({
                          selectedDate: date,
                        });
                        this.onDateFieldValueChange(date);
                      }}
                    />
                  </div>
                )}

                {this.state.isTags && (
                  <div id='vss_370' className='combo input-text-box list drop'>
                    <CustomDropdown
                      selectedItem={this.state.selectedFieldValueIds[0]}
                      selectedItems={this.state.selectedFieldValues}
                      dropdownOptions={this.state.fieldValueOptions}
                      searchable={this.state.fieldValueOptions.length >= 10}
                      placeholder={UATConstants.PlaceholdersAndTitles.ClickToAdd}
                      onChangeCallBack={this.onFieldValueChange}
                      label={UATConstants.PlaceholdersAndTitles.SelectTags}
                      title={this.state.selectedFieldValues[0]}
                      multiSelect={this.state.isMultiSelect}
                      showLogicalRadioButton={this.state.selectedFieldValueIds.length > 1}
                      onLogicalRadioButtonChangeCallBack={this.onLogicalRadioButtonChangeCallBack}
                    />
                  </div>
                )}

                {(this.state.isPicklist || this.state.isAreaPathOrIteration) && (
                  <div>
                    <CustomDropdown
                      selectedItem={this.state.selectedFieldValueIds}
                      selectedItems={this.state.selectedFieldValues}
                      dropdownOptions={this.state.fieldValueOptions}
                      searchable={this.state.fieldValueOptions.length >= 10}
                      placeholder={UATConstants.PlaceholdersAndTitles.ClickToAdd}
                      onChangeCallBack={this.onFieldValueChange}
                      label={UATConstants.PlaceholdersAndTitles.Select}
                      title={this.state.selectedFieldValues[0]}
                      multiSelect={false}
                      disabled={columnDisabled}
                      individualItem
                    />
                  </div>
                )}

                {this.state.isIdentity && (
                  <NormalPeoplePicker
                    className={this.state.isMultiSelect ? 'CustomFilterPeoplePicker' : ''}
                    itemLimit={!this.state.isMultiSelect ? 1 : 30}
                    pickerCalloutProps={{
                      preventDismissOnScroll: true,
                      calloutWidth: 400,
                    }}
                    defaultSelectedItems={
                      this.state.selectedFieldValues !== undefined
                        ? this.getDefaultPersona(
                          this.state.selectedFieldValues.length > 0
                            ? this.state.selectedFieldValues.toString()
                            : ''
                        )
                        : undefined
                    }
                    onChange={this._onChangePeopleGetAssignTo.bind(this)}
                    onResolveSuggestions={this._onPeopleFilterChanged.bind(this)}
                    pickerSuggestionsProps={this.suggestionProps}
                    disabled={columnDisabled}
                    inputProps={{
                      placeholder: 'Search users',
                    }}
                    selectedItems={
                      this.state.selectedFieldValueIds !== undefined
                        ? this.getDefaultPersona(
                          this.state.selectedFieldValueIds.length > 0
                            ? this.state.selectedFieldValueIds.toString()
                            : ''
                        )
                        : undefined
                    }
                  />
                )}
                {this.state.isCalloutVisible && (
                  <UserCard
                    userContactDetails={this.state.userContactDetails}
                    userManagerDetails={this.state.userManager}
                    setButtonId={this.setButtonId}
                  />
                )}
              </div>
            </div>
          </td>
          <td className='add-remove' aria-label={UATConstants.PlaceholdersAndTitles.RemoveCriteria}>
            <button
              title={UATConstants.PlaceholdersAndTitles.RemoveCriteria}
              className={`filter-remove-btn ${this.props.queryItemIndex === 0 ? 'displayNone' : 'cancelIcon colorRed pointer'}`}
              onClick={this.deleteItem.bind(this)}>
              <FontIcon
                className='removeButton'
                iconName={UATConstants.PlaceholdersAndTitles.Cancel}
              />
            </button>
          </td>
        </tr>
      </>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  ...state,
});

const mapDispatchToProps = {
  checkForUngroup: checkForUngroup,
  setBanner: setBanner,
};

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsFilterItem);
